import React from 'react';
import formClasses from '../../forms/form.module.scss';
import { Select } from '../../forms/Select';
import { RegisterOptions, UseFormReturn } from 'react-hook-form';
import { InputErrorMessageSeverityType, SelectItem, SelectViewProps } from '../../forms/Select/Select.view';
import { TimeFormatSetting } from '../../../models/graphql';
import classNames from 'classnames';
import classes from './TimePicker.module.scss';
import { FormElementAction } from '../../../models/basic-objects';

export type TimePickerInputRules = { [key in 'hours' | 'minutes' | 'ampm']: RegisterOptions };
export type TimePickerActions = { [key in 'hour' | 'minute' | 'ampm']: FormElementAction };

export type TimePickerViewProps = {
  //
  actions?: TimePickerActions;
  ampmInputName: string;
  disabled?: boolean;
  hoursInputName: string;
  hoursItems: SelectItem[];
  label?: string;
  minutesInputName: string;
  minutesItems: SelectItem[];
  rules: TimePickerInputRules;
  size: SelectViewProps['size'];
  timeFormat: TimeFormatSetting;
  useFormInstance: UseFormReturn;
} & InputErrorMessageSeverityType;

export const TimePickerView = ({
  actions,
  ampmInputName,
  disabled,
  hoursInputName,
  hoursItems,
  label,
  minutesInputName,
  minutesItems,
  rules,
  size,
  timeFormat,
  useFormInstance,
  errorMessage,
  errorSeverity
}: TimePickerViewProps): JSX.Element => {
  const timeSelectClasses = classNames(
    classes.TimeSelects,
    timeFormat === TimeFormatSetting.HOUR_12 ? classes.TimeSelectsThree : classes.TimeSelectsTwo
  );

  return (
    <>
      {label && <label className={formClasses.Label}>{label}</label>}
      <div className={'grid-x align-justify'}>
        <div className={timeSelectClasses}>
          <Select
            {...(typeof errorMessage === 'string' ? { errorMessage: '', errorSeverity } : {})}
            {...(actions ? { action: actions.hour } : {})}
            {...(disabled ? { disabled } : {})}
            chooseLabel={'--'}
            items={hoursItems}
            name={hoursInputName}
            size={size}
            rules={rules.hours}
            useFormInstance={useFormInstance}
          />
        </div>
        <div className={timeSelectClasses}>
          <Select
            {...(typeof errorMessage === 'string' ? { errorMessage: '', errorSeverity } : {})}
            {...(actions ? { action: actions.minute } : {})}
            {...(disabled ? { disabled } : {})}
            chooseLabel={'--'}
            items={minutesItems}
            name={minutesInputName}
            size={size}
            rules={rules.minutes}
            useFormInstance={useFormInstance}
          />
        </div>
        {timeFormat === TimeFormatSetting.HOUR_12 && (
          <div className={timeSelectClasses}>
            <Select
              {...(typeof errorMessage === 'string' ? { errorMessage: '', errorSeverity } : {})}
              {...(actions ? { action: actions.ampm } : {})}
              {...(disabled ? { disabled } : {})}
              items={[
                {
                  label: 'AM',
                  value: 'am'
                },
                {
                  label: 'PM',
                  value: 'pm'
                }
              ]}
              chooseLabel={'--'}
              name={ampmInputName}
              size={size}
              rules={rules.ampm}
              useFormInstance={useFormInstance}
            />
          </div>
        )}
      </div>
    </>
  );
};
